export const DEFAULT_SHARING_METHODS = {
  EMAIL: 'EMAIL'
};
export const DefaultSharingMethods = [{
  id: DEFAULT_SHARING_METHODS.EMAIL,
  name: 'Email',
  iconName: 'email-forwarding'
}];